/* eslint-disable import/no-named-as-default */
import React from 'react';
import { useSelector } from 'react-redux';
import { array, object, oneOfType, string } from 'prop-types';
import classNames from 'classnames/bind';
import List from 'yoda-core-components/lib/components/List/List';
import renderCurrentComponent from 'yoda-site-components/lib/components/IrisPage/renderCurrentComponent';
import { viewTypes } from '../../configurations/config';
import * as styles from './ProductList.css';
import GalleryProductCard from '../GalleryProductCard/GalleryProductCard';
import ProductMarketingTile from '../ProductMarketingTile/ProductMarketingTile';
import ProductsLoader from './ProductsLoader';
import { getURLParameterBykey } from '../../utils';

const cx = classNames.bind(styles);

/* istanbul ignore next */
const ProductListRenderer = ({
    dataSource: { adMonetization, productList },
    gridAds,
    irisComponents,
    irisComponentsWithoutGrid,
    irisPropsData,
    marketingSlot,
}) => {
    const {
        context: {
            deviceType = {},
            deviceType: { isMobile = false },
            featureFlags: { enableThreeColumnGrid = true } = {},
        } = {},
        enableLoader = false,
        multiSelectFilter: { enableProductsLoader = false } = {},
        productSettings: { isFacetOpened = false, viewType = 'grid' } = {},
    } = useSelector((store) => store);

    const scrollToProduct = getURLParameterBykey('scrollTo');

    const renderChildComponent = (product) => {
        let childComponent = (
            <GalleryProductCard
                cardType={viewType}
                fromProductList
                index={product.index}
                productDetails={product}
                scrollToProduct={scrollToProduct}
            />
        );

        if (enableProductsLoader && enableLoader) {
            childComponent = <ProductsLoader hasProducts />;
        } else if (product.marketingSlot && viewType !== viewTypes.List) {
            childComponent = (
                <ProductMarketingTile
                    deviceType={deviceType}
                    disableLoader
                    irisComponents={irisComponents}
                    irisComponentsWithoutGrid={irisComponentsWithoutGrid}
                    irisPropsData={irisPropsData}
                    marketingSlot={marketingSlot}
                    productMarketingSlot={product.marketingSlot}
                    slotPosition={product.marketingSlot.slotPosition}
                />
            );
        }

        return childComponent;
    };

    return (
        <>
            {productList && (
                <List
                    automationId="gallery-product-list"
                    childRenderer={(product) => renderChildComponent(product)}
                    datasource={productList}
                    direction="Wrap"
                    itemStyleClass={cx('list-item', 'mb-2', {
                        'w-1/2': isMobile,
                        'w-1/3': !isMobile && isFacetOpened && enableThreeColumnGrid,
                        'w-1/4': !isMobile && isFacetOpened && !enableThreeColumnGrid,
                        'w-full': viewType === viewTypes.LIST,
                    })}
                    listBodyClass={cx('list-container')}
                    listStyleClass={cx('flex', 'flex-wrap', 'list')}
                    spacing="None"
                />
            )}
            {!productList &&
                adMonetization &&
                renderCurrentComponent(
                    gridAds,
                    0,
                    irisComponents,
                    irisComponentsWithoutGrid,
                    irisPropsData
                )}
        </>
    );
};

ProductListRenderer.defaultProps = {
    gridAds: {},
    irisComponents: {},
    irisComponentsWithoutGrid: {},
    irisPropsData: {},
    marketingSlot: {},
};

ProductListRenderer.propTypes = {
    dataSource: oneOfType([array, object]).isRequired,
    gridAds: oneOfType([object, string]),
    irisComponents: oneOfType([array, object]),
    irisComponentsWithoutGrid: oneOfType([array, object]),
    irisPropsData: oneOfType([array, object]),
    marketingSlot: oneOfType([array, object]),
};

export default ProductListRenderer;
